/* eslint-disable */
export default {
  title: 'Áudio',
  input: 'Entrada',
  microphone: 'Microfone',
  autoAdjustMicLevel: 'Ajustar nível do mic automaticamente',
  output: 'Saída',
  speakerSource: 'Origem do alto-falante',
  speakerVolume: 'Volume do alto-falante',
  ringtoneSource: 'Origem do toque e da notificação',
  ringtoneVolume: 'Volume do toque e da notificação',
  ringtones: 'Toques',
  noDevices: 'Sem dispositivo',
  off: 'Desativado',
  noLabel: 'Dispositivo desconhecido',
  stopRecordDescription:
    'Fale algo para verificar o nível do seu microfone ({countDown} s)',
  stopPlaybackDescription: 'Reproduzindo sua gravação...',
  startRecordButton: 'Testar microfone',
  stopRecordButton: 'Parar gravação',
  stopPlaybackButton: 'Parar teste',
  startTestButton: 'Testar alto-falante',
  stopTestDescription: 'Reproduzindo amostra de som...',
} as const;

// @key: @#@"title"@#@ @source: @#@"Audio"@#@
// @key: @#@"input"@#@ @source: @#@"Input"@#@
// @key: @#@"microphone"@#@ @source: @#@"Microphone"@#@
// @key: @#@"autoAdjustMicLevel"@#@ @source: @#@"Automatically adjust my mic level"@#@
// @key: @#@"output"@#@ @source: @#@"Output"@#@
// @key: @#@"speakerSource"@#@ @source: @#@"Speaker source"@#@
// @key: @#@"speakerVolume"@#@ @source: @#@"Speaker volume"@#@
// @key: @#@"ringtoneSource"@#@ @source: @#@"Ringtone and notification source"@#@
// @key: @#@"ringtoneVolume"@#@ @source: @#@"Ringtone and notification volume"@#@
// @key: @#@"ringtones"@#@ @source: @#@"Ringtones"@#@
// @key: @#@"noDevices"@#@ @source: @#@"No devices"@#@
// @key: @#@"off"@#@ @source: @#@"Off"@#@
// @key: @#@"noLabel"@#@ @source: @#@"Unknown device"@#@
// @key: @#@"stopRecordDescription"@#@ @source: @#@"Say something to check your mic level ({countDown} sec)"@#@
// @key: @#@"stopPlaybackDescription"@#@ @source: @#@"Playing your recording..."@#@
// @key: @#@"startRecordButton"@#@ @source: @#@"Test microphone"@#@
// @key: @#@"stopRecordButton"@#@ @source: @#@"Stop recording"@#@
// @key: @#@"stopPlaybackButton"@#@ @source: @#@"Stop test"@#@
// @key: @#@"startTestButton"@#@ @source: @#@"Test speaker"@#@
// @key: @#@"stopTestDescription"@#@ @source: @#@"Playing sample sound..."@#@
